<template>
  <div id="input-date-range" v-outside-click="closePopup">
    <div class="date-wrapper">
      <div class="date-field">
        <div class="fs-13 text-left">Start Date</div>
        <input
          placeholder="Select"
          class="date-input"
          :class="{ 'date-input-active': activeField === 'start' }"
          v-model="startDate"
          readonly
          @click="openStartPicker"
          @focus="openStartPicker"
        />
      </div>
      <div class="date-field">
        <div class="fs-13 text-left">End Date</div>
        <input
          placeholder="Select"
          class="date-input"
          :class="{ 'date-input-active': activeField === 'end' }"
          v-model="endDate"
          readonly
          @click="openEndPicker"
          @focus="openEndPicker"
        />
      </div>
    </div>
    <div class="year-selector" v-if="activeField">
      <div class="calendar-center">
        <date-picker
          v-if="activeField === 'start'"
          @input="onStartInput"
          :value="startDateValue"
          :disabled-date="startDisabledDate"
          inline
          type="date"
        />
        <date-picker
          v-if="activeField === 'end'"
          @input="onEndInput"
          :value="endDateValue"
          :disabled-date="endDisabledDate"
          inline
          type="date"
        />
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import DatePicker from 'vue2-datepicker'
import '@/assets/css/vue2-datepicker.css'

export default {
  name: 'InputDateRange',
  props: ['value', 'disabledDate'],
  components: {
    DatePicker
  },
  data() {
    return {
      startDate: null,
      endDate: null,
      activeField: null
    }
  },
  computed: {
    startDateValue() {
      return this.value && this.value[0] ? this.value[0] : null
    },
    endDateValue() {
      return this.value && this.value[1] ? this.value[1] : null
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(value) {
        if (value && value[0] && value[1]) {
          this.startDate = moment(value[0]).format('YYYY-MM-DD')
          this.endDate = moment(value[1]).format('YYYY-MM-DD')
        } else {
          this.startDate =
            value && value[0] ? moment(value[0]).format('YYYY-MM-DD') : null
          this.endDate =
            value && value[1] ? moment(value[1]).format('YYYY-MM-DD') : null
        }
      }
    }
  },
  methods: {
    openStartPicker() {
      this.activeField = 'start'
    },
    openEndPicker() {
      this.activeField = 'end'
    },
    closePopup() {
      this.activeField = null
    },
    startDisabledDate(date) {
      if (this.disabledDate) {
        return this.disabledDate(date)
      }
      return false
    },
    endDisabledDate(date) {
      if (this.startDateValue) {
        const start = new Date(this.startDateValue)
        start.setHours(0, 0, 0, 0)
        if (date < start) {
          return true
        }
      }
      if (this.disabledDate) {
        return this.disabledDate(date)
      }
      return false
    },
    onStartInput(date) {
      const currentEnd = this.endDateValue
      let end = currentEnd || date
      if (currentEnd && new Date(currentEnd) < new Date(date)) {
        end = date
      }
      this.$emit('input', [date, end])
      this.startDate = moment(date).format('YYYY-MM-DD')
      this.endDate = moment(end).format('YYYY-MM-DD')
      this.activeField = null
    },
    onEndInput(date) {
      const currentStart = this.startDateValue
      let start = currentStart || date
      if (currentStart && new Date(currentStart) > new Date(date)) {
        start = date
      }
      this.$emit('input', [start, date])
      this.startDate = moment(start).format('YYYY-MM-DD')
      this.endDate = moment(date).format('YYYY-MM-DD')
      this.activeField = null
    }
  }
}
</script>

<style scoped>
#input-date-range {
  position: relative;
  width: 100%;
}

.date-wrapper {
  display: flex;
  align-items: flex-end;
  gap: 16px;
  width: 100%;
}

.date-field {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.year-selector {
  position: relative;
  z-index: 2;
  display: flex;
  justify-content: center;
  width: 100%;
  margin-top: 8px;
}

.calendar-center {
  flex: 0 0 auto;
}

.date-input {
  width: 100%;
  min-width: 0;
  height: 40px;
  box-sizing: border-box;
  border-radius: 5px;
  border: solid 1px #cbd4dc;
  padding: 0 32px 0 12px;
  background: no-repeat;
  background-image: url('~@/assets/calendar-green-2.svg');
  background-position: right 10px center;
  background-size: 16px;
  font-family: Montserrat;
  font-size: 13px;
  color: #4a4a4a;
  cursor: pointer;
}

.date-input-active {
  border-color: var(--rentalios-dark, #4a8d00);
}

@media (max-width: 768px) {
  .date-wrapper {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
  }
}

@media (max-width: 480px) {
  .year-selector {
    position: fixed;
    left: 50%;
    right: auto;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 10000;
    width: auto;
    max-width: calc(100vw - 24px);
    justify-content: center;
    background: #fff;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
    border-radius: 8px;
    padding: 8px;
    box-sizing: border-box;
  }
}

.calendar-center ::v-deep .mx-datepicker,
.calendar-center ::v-deep .mx-datepicker-inline {
  display: inline-block !important;
  width: auto !important;
}

::v-deep .mx-calendar-content .cell.in-range {
  background-color: #eff7e7;
}
::v-deep .mx-calendar-content .cell.hover-in-range {
  background-color: #eff7e7;
}
</style>
